import React from 'react';
import { BodySm } from 'TMComponents/Typography';
import NavLink from 'TMComponents/NavLink';
import { string } from 'prop-types';

const ColumnLink = ({ link, text }) => (
    <NavLink href={link}>
        <BodySm>{text}</BodySm>
    </NavLink>
);

ColumnLink.propTypes = {
    link: string.isRequired,
    text: string.isRequired
};

export default ColumnLink;
